interface ErrorMessageProps {
  message?: string | null | undefined;
}

export default function ErrorMessage({ message }: ErrorMessageProps) {
  if (!message) {
    return null;
  }
  return <span className="mt-[-1.25rem] block text-sm text-red-500">{message}</span>;
}
